import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button } from 'reactstrap';
import {
  getMemberOnboard,
  getMemberOnboardStatus,
  getOnBoardMmber,
  getOnboardTeam,
  sendMemberReminder,
  getMembersCSV,
  getMembersXLSX,
  deleteOnboardingMember,
} from '../../../../redux/MainAction';
import PaginationComponent from '../../filters/PaginationComponent';
import { downloadCSV, downloadXLS } from '../../../../helpers/helpers';
import { FaFileCsv, FaFileExcel } from 'react-icons/fa';

const OnboardingStatus = () => {
  const dispatch = useDispatch();
  const list = useSelector((state) => state.Webtracker.onBoardUser);
  // const emp = useSelector((state) => state.Webtracker.onBoardMembers);
  const tms = useSelector((state) => state.Webtracker.onBoardTeams);
  const status = useSelector((state) => state.Webtracker.onBoardStatus);

  const [filter, setFilter] = useState({
    teamIds: '',
    roles: '',
    search: '',
  });

  const [allUser, setAllUser] = useState([]);

  const [showReset, setShowReset] = useState(false);
  const [page, setPage] = useState(1); // Current page
  const [totalPages, setTotalPages] = useState(0); // Total number of pages
  const itemsPerPage = 10;

  console.log(allUser);

  const onChangeFilter = (e) => {
    setFilter({
      ...filter,
      [e.target.name]: e.target.value,
    });
  };

  useEffect(() => {
    getList();
  }, [page]);

  const getList = () => {
    var data = {
      offset: (page - 1) * itemsPerPage,
      limit: itemsPerPage,
    };
    dispatch(getMemberOnboard(data));
    // dispatch(getOnBoardMmber(data));
  };

  useEffect(() => {
    if (!tms || !Array.isArray(tms?.rows)) {
      var data = {
        offset: (page - 1) * itemsPerPage,
        limit: itemsPerPage,
      };
      dispatch(getOnboardTeam(data));
    }
  }, [tms]);

  useEffect(() => {
    dispatch(getMemberOnboardStatus());
  }, []);

  const sendRimnd = (id) => {
    var ID = {
      id: id,
    };
    dispatch(sendMemberReminder(ID));
  };

  const handleApply = (e) => {
    e.preventDefault();

    const payload = {
      offset: 0,
      limit: 10,
    };

    if (filter?.teamIds !== '') {
      payload.teamIds = [filter.teamIds];
    }
    if (filter?.roles !== '') {
      payload.roles = [filter.roles];
    }
    if (filter?.search !== '') {
      payload.search = filter.search;
    }
    dispatch(getMemberOnboard(payload));
    setShowReset(true);
  };

  useEffect(() => {
    if (list?.rows) {
      setAllUser(list?.rows);
      setTotalPages(Math.ceil(list.count / itemsPerPage));
    }
  }, [list]);

  const handlePageChange = (event, value) => {
    setPage(value);
  };

  const handleReset = (e) => {
    e.preventDefault();

    const pay = {
      offset: 0,
      limit: 10,
    };
    dispatch(getMemberOnboard(pay));
    setFilter({ teamIds: '', roles: '', search: '' });
    setShowReset(false);
  };

  async function downloadCSVHandler(isCSV) {
    const payload = {};

    if (filter?.teamIds !== '') {
      payload.teamIds = [filter.teamIds];
    }
    if (filter?.roles !== '') {
      payload.roles = [filter.roles];
    }
    if (filter?.search !== '') {
      payload.search = filter.search;
    }

    if (isCSV) {
      const csv = await dispatch(getMembersCSV(payload, '/onboard/member'));
      downloadCSV(csv, 'Onboarding Members Report');
    } else {
      const xlsx = await dispatch(getMembersXLSX(payload, '/onboard/member'));
      downloadXLS(xlsx, 'Onboarding Members Report');
    }
  }

  const deleteUser = (id) => {
    dispatch(
      deleteOnboardingMember({
        id,
      })
    );
  };

  return (
    <div>
      <div className="card mt-2 mb-2">
        <div
          className="card-body d-flex justify-content-start align-items-center font-14"
          style={{ gap: '20px' }}
        >
          <div
            className="d-flex justify-content-start  flex-column"
            style={{ borderRight: '1px solid #ccc', paddingRight: '20px' }}
          >
            <span>Invitation Sent</span>
            <span>{status?.invitationSent}</span>
          </div>
          <div
            className="d-flex justify-content-start  flex-column"
            style={{ borderRight: '1px solid #ccc', paddingRight: '20px' }}
          >
            <span>Invitation Accepted</span>
            <span>{status?.invitationAccepted}</span>
          </div>
          <div
            className="d-flex justify-content-start  flex-column"
            style={{ borderRight: '1px solid #ccc', paddingRight: '20px' }}
          >
            <span>Logged into Desktop App</span>
            <span>{status?.loggedIntoDesktopApp}</span>
          </div>
          <div
            className="d-flex justify-content-start  flex-column"
            style={{ borderRight: '1px solid #ccc', paddingRight: '20px' }}
          >
            <span>Tracked Time</span>
            <span>{status?.trackedTime}</span>
          </div>
          <div
            className="d-flex justify-content-start  flex-column"
            style={{ borderRight: '1px solid #ccc', paddingRight: '20px' }}
          >
            <span>Outdated Tracker</span>
            <span>{status?.outdatedTracker}</span>
          </div>
          <div
            className="d-flex justify-content-start  flex-column"
            style={{ borderRight: '1px solid #ccc', paddingRight: '20px' }}
          >
            <span>Mac users</span>
            <span>{status?.macUsers}</span>
          </div>
          <div
            className="d-flex justify-content-start  flex-column"
            style={{ borderRight: '1px solid #ccc', paddingRight: '20px' }}
          >
            <span>Windows users</span>
            <span>{status?.windowsUsers}</span>
          </div>
          <div
            className="d-flex justify-content-start  flex-column"
            style={{ borderRight: '1px solid #ccc', paddingRight: '20px' }}
          >
            <span>Linux users</span>
            <span>{status?.linuxUsers}</span>
          </div>
        </div>
      </div>
      <div className="d-flex justify-content-between align-items-center mt-2 mb-2">
        <div
          className="d-flex justify-content-start align-items-center"
          style={{ gap: '10px' }}
        >
          <div className="fillSelect">
            <input
              type="text"
              placeholder="Search by email..."
              name="search"
              className="form-control py-2 ps-3 rounded-3 border-secondary-subtle"
              value={filter?.search}
              onChange={onChangeFilter}
            />
          </div>

          <div className="fillSelect">
            <i className="mdi mdi-briefcase font-20 fillIcon"></i>
            <select
              className="form-control font-14"
              name="teamIds"
              value={filter?.teamIds}
              onChange={onChangeFilter}
            >
              <option value={''}>All Teams</option>
              {tms?.rows?.map((mems, idx) => (
                <option key={idx} value={mems?.id}>
                  {mems?.name}
                </option>
              ))}
            </select>
          </div>
          <div className="fillSelect">
            <i className="mdi mdi-account-multiple-outline font-20 fillIcon"></i>
            <select
              className="form-control font-14"
              name="roles"
              value={filter?.roles}
              onChange={onChangeFilter}
            >
              <option value={''}>All Type Roles</option>
              <option value="EXECUTIVE-MANAGER">Executive Manager</option>
              <option value="OWNER">Owner</option>
              <option value="TEAM-MANAGER">Team Manager</option>
              <option value="PROJECT-MANAGER">Project Manager</option>
              <option value="EMPLOYEE">Employee</option>
            </select>
          </div>
          <Button
            className="d-flex align-items-center justify-content-center"
            style={{ padding: '6px 14px' }}
            size="sm"
            color="primary"
            onClick={handleApply}
          >
            <i className="ion-ios7-search font-20"></i>
          </Button>
          {showReset ? (
            <Button
              className="d-flex align-items-center justify-content-center"
              style={{ padding: '6px 13px' }}
              size="sm"
              color="danger"
              onClick={handleReset}
            >
              <i className="mdi mdi-close font-20"></i>
            </Button>
          ) : (
            ''
          )}

          <Button
            color="success"
            size="sm"
            className="mr-2 d-flex align-items-center"
            onClick={() => downloadCSVHandler(true)}
          >
            <FaFileCsv className="mr-1" /> CSV
          </Button>
          {/* <Button
            color="primary"
            size="sm"
            className="d-flex align-items-center"
            onClick={() => downloadCSVHandler()}
          >
            <FaFileExcel className="mr-1" /> XLSX
          </Button> */}
        </div>
      </div>
      <table
        id="datatable"
        className="table dt-responsive nowrap table-vertical"
        width="100%"
        cellSpacing="0"
      >
        <thead>
          <tr>
            <th>No.</th>
            <th>Email</th>
            <th>Accepted Invitation</th>
            <th>Logged into Desktop App</th>
            <th>Tracked Time</th>
            <th>Desktop Tracker Version</th>
            <th>OS</th>
            <th>Send Reminder</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {allUser?.length > 0 ? (
            allUser?.map((item, idx) => {
              return (
                <tr key={item?.id}>
                  <td>{idx + 1 + (page - 1) * itemsPerPage}</td>
                  <td>{item?.email}</td>
                  <td>
                    <div style={{ display: 'flex', gap: '10px' }}>
                      {item?.hasAcceptedInvitation ? (
                        <i
                          className="   mdi mdi-check font-20 Edit_Icons"
                          style={{ cursor: 'pointer', color: 'green' }}
                          data-toggle="tooltip"
                          data-placement="top"
                          title="Edit Details"
                        ></i>
                      ) : (
                        <i
                          className="  mdi mdi-window-close font-20 Edit_Icons"
                          style={{ cursor: 'pointer', color: 'red' }}
                          data-toggle="tooltip"
                          data-placement="top"
                          title="Edit Details"
                          // onClick={()=>toggleModal(item?.id)}
                        ></i>
                      )}
                    </div>
                  </td>
                  <td>
                    <div style={{ display: 'flex', gap: '10px' }}>
                      {item?.hasLoggedIntoDesktopApp ? (
                        <i
                          className="   mdi mdi-check font-20 Edit_Icons"
                          style={{ cursor: 'pointer', color: 'green' }}
                          data-toggle="tooltip"
                          data-placement="top"
                          // title="Edit Details"
                        ></i>
                      ) : (
                        <i
                          className="  mdi mdi-window-close font-20 Edit_Icons"
                          style={{ cursor: 'pointer', color: 'red' }}
                          data-toggle="tooltip"
                          data-placement="top"
                          // title="Edit Details"
                          // onClick={()=>toggleModal(item?.id)}
                        ></i>
                      )}
                    </div>
                  </td>
                  <td>
                    <div style={{ display: 'flex', gap: '10px' }}>
                      {item?.hasTrackedTime ? (
                        <i
                          className="   mdi mdi-check font-20 Edit_Icons"
                          style={{ cursor: 'pointer', color: 'green' }}
                          data-toggle="tooltip"
                          data-placement="top"
                          // title="Edit Details"
                        ></i>
                      ) : (
                        <i
                          className="  mdi mdi-window-close font-20 Edit_Icons"
                          style={{ cursor: 'pointer', color: 'red' }}
                          data-toggle="tooltip"
                          data-placement="top"
                          // title="Edit Details"
                          // onClick={()=>toggleModal(item?.id)}
                        ></i>
                      )}
                    </div>
                  </td>
                  <td>{item?.desktopTrackerVersion || 'N/A'}</td>
                  <td>{item?.operatingSystem || 'N/A'}</td>
                  <td>
                    <div style={{ display: 'flex', gap: '10px' }}>
                      <i
                        className="fa fa-send (alias) font-20 Edit_Icons"
                        style={{ cursor: 'pointer' }}
                        data-toggle="tooltip"
                        data-placement="top"
                        title="Send Reminder"
                        onClick={() => sendRimnd(item?.id)}
                      ></i>
                    </div>
                  </td>

                  <td>
                    <div style={{ display: 'flex', gap: '10px' }}>
                      <i
                        className="fa fa-trash text-danger font-20 Edit_Icons"
                        style={{ cursor: 'pointer' }}
                        data-toggle="tooltip"
                        data-placement="top"
                        title="Delete User"
                        onClick={() => deleteUser(item?.id)}
                      ></i>
                    </div>
                  </td>
                </tr>
              );
            })
          ) : (
            <tr>
              <td colSpan="9" className="text-center">
                No Records Found
              </td>
            </tr>
          )}
        </tbody>
      </table>
      <PaginationComponent
        count={totalPages}
        page={page}
        onPageChange={handlePageChange}
      />
    </div>
  );
};

export default OnboardingStatus;
